var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Collapse",
    {
      staticClass: "project-rep",
      attrs: {
        title: _vm.$t("project.representative.title"),
        enableExpandByClickingTitle: true,
        withBorder: false,
        arrowStyle: "accordion",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "project-rep__box",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("div", { staticClass: "project-rep__header" }, [
            _c("div", { staticClass: "project-rep__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("project.representative.subTitle")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.isPicView
              ? _c(
                  "div",
                  { staticClass: "project-rep__btns" },
                  [
                    !_vm.editable
                      ? _c("HKLButton", {
                          attrs: {
                            color: "darkblue",
                            action: "edit",
                            disabled: !_vm.canEditRepresentative,
                          },
                          on: {
                            click: function () {
                              return (_vm.editable = true)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editable
                      ? _c("HKLButton", {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          attrs: { color: "darkblue", action: "cancel" },
                          on: {
                            click: function () {
                              return _vm.cancel()
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.editable
                      ? _c("HKLButton", {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          attrs: { color: "orange", action: "save" },
                          on: {
                            click: function () {
                              return _vm.save()
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.editable
            ? _c(
                "div",
                { staticClass: "flex-table project-rep__form" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex-table__header flex-table__header-label",
                    },
                    [
                      _vm._l(_vm.editHeadersMap, function (headItem) {
                        return _c(
                          "label",
                          {
                            key: headItem.labelKey,
                            staticClass: "flex-table__col",
                            class: [
                              headItem.labelKey,
                              headItem.required ? "required-flag" : "",
                            ],
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("table.header." + headItem.labelKey)
                                ) +
                                "\n        "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("HKLDeleteIcon", {
                        staticClass: "flex-table__del-col hidden",
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.pendingAccounts, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex-table__body" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex-table__col input-name" },
                          _vm._l(_vm.sortedFullName, function (fullnameObj) {
                            return _c("HKLInput", {
                              directives: [
                                {
                                  name: "fusioninputcheck",
                                  rawName: "v-fusioninputcheck",
                                  value: {
                                    type: "string",
                                    required: true,
                                  },
                                  expression:
                                    "{\n              type: 'string',\n              required: true,\n            }",
                                },
                              ],
                              key: fullnameObj.value,
                              attrs: {
                                placeholder: _vm.$t(
                                  "contact.basic." + fullnameObj.label
                                ),
                              },
                              model: {
                                value: item[fullnameObj.value],
                                callback: function ($$v) {
                                  _vm.$set(item, fullnameObj.value, $$v)
                                },
                                expression: "item[fullnameObj.value]",
                              },
                            })
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-table__col input-email" },
                          [
                            _c("HKLInputEmail", {
                              class: _vm.invalidEmailClassesMap[index],
                              attrs: {
                                checkerOptions: {
                                  type: "String",
                                  required: true,
                                  patternOnly: function () {
                                    return _vm.checkInputEmail(item.email)
                                  },
                                  showTip: false,
                                },
                              },
                              model: {
                                value: item.email,
                                callback: function ($$v) {
                                  _vm.$set(item, "email", $$v)
                                },
                                expression: "item.email",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-table__col input-phone" },
                          [
                            _c("HKLInput", {
                              directives: [
                                {
                                  name: "fusioninputcheck",
                                  rawName: "v-fusioninputcheck",
                                  value: {
                                    type: "string",
                                    required: true,
                                  },
                                  expression:
                                    "{\n              type: 'string',\n              required: true,\n            }",
                                },
                              ],
                              model: {
                                value: item.phone,
                                callback: function ($$v) {
                                  _vm.$set(item, "phone", $$v)
                                },
                                expression: "item.phone",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-table__col input-otherPhone" },
                          [
                            _c("HKLInput", {
                              model: {
                                value: item.altPhone,
                                callback: function ($$v) {
                                  _vm.$set(item, "altPhone", $$v)
                                },
                                expression: "item.altPhone",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("HKLDeleteIcon", {
                          on: {
                            click: function () {
                              return _vm.preDeleteAccount(item, index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "project-rep__add underline pointer",
                      on: {
                        click: function () {
                          return _vm.addAccount()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.addProjectRep")) +
                          "+\n      "
                      ),
                    ]
                  ),
                ],
                2
              )
            : _c(
                "div",
                {
                  class: ["flex-table", { creator: _vm.canEditRepresentative }],
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex-table__header" },
                    [
                      _vm._l(_vm.headersMap, function (item, index) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticClass: "flex-table__col",
                            class: item.labelKey,
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("table.header." + item.labelKey))
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.canEditRepresentative,
                            expression: "canEditRepresentative",
                          },
                        ],
                        staticClass: "invite-col",
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.pendingAccounts, function (item, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "flex-table__body" },
                      [
                        _vm._l(_vm.headersMap, function (headItem) {
                          return _c(
                            "span",
                            {
                              key: headItem.labelKey,
                              staticClass: "flex-table__col",
                              class: headItem.labelKey,
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("isEmptyValue")(
                                    item[headItem.labelKey]
                                  )
                                )
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.canEditRepresentative,
                                expression: "canEditRepresentative",
                              },
                            ],
                            staticClass: "invite-col",
                            class: item.showInviteClass,
                          },
                          [
                            _c("HKLButton", {
                              attrs: { color: "orange", action: "invite" },
                              on: {
                                click: function () {
                                  return _vm.invite(item.id)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
          _vm._v(" "),
          _c("HKLModal", {
            ref: "delModalRef",
            on: {
              onOkClick: function () {
                return _vm.delAccount(_vm.deleteIndex)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("hint.deleteProjectRepresentative")) +
                        "\n      "
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("HKLInviteModal", {
            ref: "inviteAllRef",
            attrs: {
              listTitle: _vm.$t("project.representative.subTitle"),
              accountsList: _vm.needInviteAccounts,
            },
            on: {
              onInviteClick: function () {
                return _vm.inviteAll(_vm.needInviteAccounts)
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }